;(function () {
	window.__lContactRevealActive = true

	let contactRevealObserver = null

	function initContactReveals(root) {
		const els = getRevealTargets(root, ':not(.is-revealed)')
		const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

		if (!els.length) {
			if (!document.querySelector('[data-l-contact-reveal]:not(.is-revealed)')) {
				document.documentElement.classList.remove('l-contact-reveal-prep')
			}

			return
		}

		if (prefersReducedMotion || !window.gsap || !window.IntersectionObserver) {
			revealContactStatic(root)

			return
		}

		if (contactRevealObserver) contactRevealObserver.disconnect()

		contactRevealObserver = new IntersectionObserver(handleContactRevealEntries, {
			root: null,
			rootMargin: '0px 0px -16% 0px',
			threshold: 0.01,
		})

		els.forEach(function (el) {
			el.classList.add('is-reveal-bound')
			contactRevealObserver.observe(el)
		})
	}

	function getRevealScope(root) {
		if (root && root.querySelectorAll) return root

		return document
	}

	function getRevealTargets(root, suffix) {
		const scope = getRevealScope(root)
		const selector = '[data-l-contact-reveal]' + (suffix || '')
		const els = Array.from(scope.querySelectorAll(selector))

		if (scope.matches && scope.matches(selector)) {
			els.unshift(scope)
		}

		return els
	}

	function handleContactRevealEntries(entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return

			contactRevealObserver.unobserve(entry.target)
			try {
				playContactReveal(entry.target)
			} catch (error) {
				markContactRevealComplete(entry.target)
			}
		})
	}

	function playContactReveal(el) {
		if (el.classList.contains('is-revealed') || el.classList.contains('is-revealing')) return

		const config = getContactRevealConfig(el)
		const parts = getContactRevealParts(el)
		const media = getContactRevealMedia(el)
		const animatedTargets = [el].concat(parts, media)
		const tl = window.gsap.timeline({
			defaults: {
				ease: 'power3.out',
				overwrite: 'auto',
			},
			onComplete: function () {
				markContactRevealComplete(el)
				window.gsap.set(animatedTargets.length ? animatedTargets : el, {
					clearProps: 'opacity,visibility,transform,willChange',
				})
			},
		})

		el.classList.add('is-revealing')
		window.gsap.set(animatedTargets.length ? animatedTargets : el, { willChange: 'transform,opacity' })

		tl.fromTo(el, getContactRevealFrom(config.shell), getContactRevealTo(config.shell), 0)

		if (parts.length) {
			tl.fromTo(parts, getContactRevealFrom(config.parts), getContactRevealTo(config.parts), 0.08)
		}

		if (media.length) {
			tl.fromTo(media, getContactRevealFrom(config.media), getContactRevealTo(config.media), config.mediaAt)
		}
	}

	function markContactRevealComplete(el) {
		el.classList.remove('is-reveal-bound')
		el.classList.remove('is-revealing')
		el.classList.add('is-revealed')

		if (!document.querySelector('[data-l-contact-reveal]:not(.is-revealed)')) {
			document.documentElement.classList.remove('l-contact-reveal-prep')
		}
	}

	function revealContactStatic(root) {
		document.documentElement.classList.remove('l-contact-reveal-prep')
		getRevealTargets(root).forEach(function (el) {
			markContactRevealComplete(el)
		})
	}

	function getContactRevealFrom(vars) {
		const from = {}

		copyContactRevealProp(vars, from, 'scale')
		copyContactRevealProp(vars, from, 'transformOrigin')
		copyContactRevealProp(vars, from, 'x')
		copyContactRevealProp(vars, from, 'y')

		if (vars.opacity !== undefined) from.autoAlpha = vars.opacity

		return from
	}

	function getContactRevealTo(vars) {
		const to = {}

		copyContactRevealProp(vars, to, 'duration')
		copyContactRevealProp(vars, to, 'ease')
		copyContactRevealProp(vars, to, 'stagger')
		copyContactRevealProp(vars, to, 'transformOrigin')

		if (vars.opacity !== undefined) to.autoAlpha = 1
		if (vars.scale !== undefined) to.scale = 1
		if (vars.x !== undefined) to.x = 0
		if (vars.y !== undefined) to.y = 0

		return to
	}

	function copyContactRevealProp(source, target, prop) {
		if (source[prop] !== undefined) {
			target[prop] = source[prop]
		}
	}

	function getContactRevealConfig(el) {
		const config = {
			shell: {
				opacity: 0,
				y: 16,
				duration: 0.65,
				ease: 'power2.out',
			},
			parts: {
				opacity: 0,
				y: 18,
				scale: 0.99,
				duration: 0.72,
				stagger: { each: 0.045, from: 'start' },
			},
			media: {
				scale: 1.025,
				duration: 1,
				ease: 'power2.out',
				transformOrigin: '50% 55%',
			},
			mediaAt: 0,
		}

		if (el.classList.contains('l-contact-hero__inner')) {
			config.shell = {
				opacity: 0,
				scale: 0.985,
				duration: 0.75,
				ease: 'power2.out',
			}
			config.parts = {
				opacity: 0,
				y: -10,
				scale: 0.985,
				duration: 0.85,
				stagger: 0.06,
				transformOrigin: '50% 50%',
			}
			config.media.scale = 1.035
			config.media.duration = 1.2
		} else if (el.classList.contains('l-contact-main__inner')) {
			config.parts = {
				opacity: 0,
				x: function (index, node) {
					if (node.classList.contains('l-contact-map')) return 12
					if (node.classList.contains('l-contact-detail')) return index % 2 === 0 ? -10 : 10

					return 0
				},
				y: function (index, node) {
					return node.classList.contains('l-contact-field') || node.classList.contains('l-contact-help-card') ? 10 : 0
				},
				scale: function (index, node) {
					return node.classList.contains('l-contact-help-card') ? 0.985 : 1
				},
				duration: 0.74,
				stagger: { each: 0.045, from: 'start' },
			}
			config.mediaAt = 0.08
		} else if (el.classList.contains('l-contact-reservation__inner')) {
			config.parts = {
				opacity: 0,
				y: 12,
				scale: 0.99,
				duration: 0.74,
				stagger: { each: 0.055, from: 'start' },
			}
		}

		return config
	}

	function getContactRevealParts(el) {
		let selector

		if (el.classList.contains('l-contact-hero__inner')) {
			selector = '.l-contact-hero__title'
		} else if (el.classList.contains('l-contact-main__inner')) {
			selector =
				'.l-contact-main__heading, .l-contact-field, .l-contact-main__submit, .l-contact-map, .l-contact-detail, .l-contact-help-card'
		} else if (el.classList.contains('l-contact-reservation__inner')) {
			selector =
				'.l-contact-reservation__logo, .l-contact-reservation__heading, .l-contact-reservation__address, .l-contact-reservation__brand'
		}

		return selector ? getVisibleNodes(el.querySelectorAll(selector)) : []
	}

	function getContactRevealMedia(el) {
		return getVisibleNodes(el.querySelectorAll('.l-contact-hero__img, .l-contact-map__frame-wrap'))
	}

	function getVisibleNodes(nodes) {
		const seen = []

		return Array.prototype.filter.call(nodes, function (node) {
			if (!node || seen.indexOf(node) !== -1 || !node.getClientRects().length) return false
			seen.push(node)

			return true
		})
	}

	function safeInitContactPage(root) {
		try {
			initContactReveals(root)
		} catch (error) {
			revealContactStatic(root)
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			safeInitContactPage(document)
		})
	} else {
		safeInitContactPage(document)
	}

	if (window.Shopify && window.Shopify.designMode) {
		document.addEventListener('shopify:section:load', function (event) {
			document.documentElement.classList.remove('l-contact-reveal-prep')
			safeInitContactPage(event.target)
		})
	}
})()
